import React, { useState } from "react";
import { TextInput } from "../../components/FormField.js";

/**
 * 自持输入态的文本框：每键只重渲染自己，不触发整页 setState。
 * 父级把草稿写进 ref，保存时读 ref；勾选/排序仍走 setState。
 */
export const IsolatedDraftInput = React.memo(function IsolatedDraftInput(props: {
  initial: string;
  onDraft: (next: string) => void;
  className?: string;
  placeholder?: string;
  "aria-label"?: string;
}): JSX.Element {
  const [val, setVal] = useState(props.initial);
  return (
    <TextInput
      value={val}
      aria-label={props["aria-label"]}
      placeholder={props.placeholder}
      className={props.className}
      onChange={(e) => {
        const next = e.target.value;
        setVal(next);
        props.onDraft(next);
      }}
    />
  );
});
